import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { StartComponent } from './start/start.component';
import { BeheerSettingsComponent } from './beheer-settings/beheer-settings.component';
import { BeheerTakenComponent } from './beheer-taken/beheer-taken.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { IncidentenComponent } from './incidenten/incidenten.component';
import { LogoutComponent } from './logout/logout.component';
import { BeheerRegelsComponent } from './beheer-regels/beheer-regels.component';
import { RegelComponent } from './beheer-regels/regel.component';
import { RegelSetActieComponent } from './beheer-regels/regel-set-actie.component';
import { RegelSetDetailsComponent } from './beheer-regels/regel-set-details.component';

const routes: Routes = [
  { path: '', component: StartComponent, canActivate: [AuthGuardService] },
  {
    path: 'settings',
    component: BeheerSettingsComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'taken',
    component: BeheerTakenComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: '',
    children: [
      {
        path: 'regelSet',
        component: BeheerRegelsComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'regelSetDetails/:regelSetId',
        component: RegelSetDetailsComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'regel/:regelSetId',
        component: RegelComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'regelSetActie/:regelSetId',
        component: RegelSetActieComponent,
        canActivate: [AuthGuardService]
      }
    ]
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: 'incidenten',
    component: IncidentenComponent,
    canActivate: [AuthGuardService]
  },
  { path: 'logout', component: LogoutComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
